import {AOperation} from "./AOperation";
import ModelsRegExp from "../../services/ModelsRegExp";
import {EOperationType} from "../utils/EOperationType";
import {Icon} from "../Icon";
import GPSCoordinates from "../GPSCoordinates";

export abstract class AOperationWithEquipment extends AOperation {

    private _equipmentId: string | undefined;

    protected constructor(id: string, idUser: string, type: EOperationType, date: Date, icon: Icon, geolocation?: GPSCoordinates, isSynchro?: boolean, commentary?: string, equipmentId?: string) {
        super(id, idUser, type, date, icon, geolocation, isSynchro, commentary);
        this._equipmentId = equipmentId;
    }

    get equipmentId(): string | undefined {
        return this._equipmentId;
    }

    set equipmentId(value: string | undefined) {
        this._equipmentId = value;
    }

    private isEquipmentIdCorrect(): boolean {
        let isCorrect = false;
        if(this._equipmentId !== undefined) {
            const match = ModelsRegExp.elementUnknown.exec(this._equipmentId);
            if(match) {
                isCorrect = true;
            }
        }
        return isCorrect;
    }

    isCorrect(): boolean {
        return (
            super.isCorrect() &&
            this.isEquipmentIdCorrect()
        );
    }

}
